export default {
  button: {
    border: '1px solid',
    borderRadius: '40px',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: 1,
    px: 2,
    py: 1.5,
    textTransform: 'none',
    '&.MuiButton-contained': {
      backgroundColor: 'background.brand.color_2',
      borderColor: 'background.brand.color_2',
      color: 'text.white',
    },
    '&.MuiButton-outlined': {
      backgroundColor: 'transparent',
      borderColor: 'background.brand.color_2',
      color: 'text.brand.color_2',
    },
    '&.MuiButton-text': {
      border: 'none',
      color: 'text.brand.color_2',
    },
    '& .MuiButton-endIcon': {
      ml: 0.5,
    },
    '&:disabled': {
      opacity: 0.5,
    },
  },
};
